const currentLocale = Shopify.locale + "-" + Shopify.country;

const handleLocaleBlocks = () => {
document.querySelectorAll('.cl-po--option[data-option="html"]').forEach(optionBlock => {
    optionBlock.querySelectorAll('[data-locale]').forEach(el => {
    if (el.getAttribute('data-locale') !== currentLocale) {
        el.remove(); // ❌ Remove elements that don't match
    }
    });
});
};

// Watch for dynamically injected content (e.g. by Shopify apps)
const observer = new MutationObserver(() => {
handleLocaleBlocks();
});

observer.observe(document.body, {
childList: true,
subtree: true
});

// Initial run
// document.addEventListener("DOMContentLoaded", handleLocaleBlocks);

handleLocaleBlocks();